import dayjs from 'dayjs';
import { List, ListItemButton } from '@mui/material';
import DisciplineIcon from './DisciplineIcon';

function getMjesec(datum) {
  if (!datum) return '';
  const m = dayjs(datum).format('MMM');
  if (m === 'May') return 'Maj';
  if (m === 'Oct') return 'Okt';
  return m;
}

function getDan(datum) {
  if (!datum) return '';
  return dayjs(datum).format('DD');
}

export default function Discipline({ discipline = [] }) {
  return (
    <div>
      <div className="marks-container">
            <List sx={{ p: 0, m: 0 }}>
              {discipline.map((item, index) => (
                <ListItemButton key={index} sx={{ p: 0, m: 0 }}>
                  <div className="main-flex-container">
                    <DisciplineIcon naziv_tipa={item.naziv_tipa} />
                    <div className="right-flex-container">
                      <div className="upper-flex-container">
                        <div className="main-text">{item.naziv_tipa}</div>
                      </div>
                      <div className="bottom-flex-container w-100" style={{ marginTop: 5 }}>
                        <div>{item.napomena || ''}</div>
                      </div>
                    </div>
                    <div className="date-container">
                      <div>{getDan(item.datum_izricanja)}</div>
                      <div>{getMjesec(item.datum_izricanja)}</div>
                    </div>
                  </div>
                </ListItemButton>
              ))}
            </List>
      </div>
    </div>
  );
}
